import React, { useState } from "react";
import {
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Collapse,
  Button,
  Box,
} from "@mui/material";
import { Link } from "react-router-dom";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";

const MobileDrawer = ({ open, toggleDrawer, loggedIn, role, dashboardPath, handleLogout }) => {
  const [mobileUsersOpen, setMobileUsersOpen] = useState(false);
  const [mobileLoansOpen, setMobileLoansOpen] = useState(false);
  const [mobileLinksOpen, setMobileLinksOpen] = useState(false);

  return (
    <Drawer anchor="left" open={open} onClose={toggleDrawer(false)}>
      <List style={{ width: "250px", paddingBottom: "60px" }}>
        {loggedIn ? (
          <>
            <ListItem disablePadding>
              <ListItemButton component={Link} to={dashboardPath} onClick={toggleDrawer(false)}>
                <ListItemText primary="Dashboard" />
              </ListItemButton>
            </ListItem>

            <ListItem disablePadding>
              <ListItemButton component={Link} to="/company-list" onClick={toggleDrawer(false)}>
                <ListItemText primary="Company List" />
              </ListItemButton>
            </ListItem>

            {["super_admin", "manager"].includes(role) && (
              <>
                <ListItem disablePadding onClick={() => setMobileUsersOpen(!mobileUsersOpen)}>
                  <ListItemButton>
                    <ListItemText primary="Users" />
                    {mobileUsersOpen ? <ExpandLess /> : <ExpandMore />}
                  </ListItemButton>
                </ListItem>
                <Collapse in={mobileUsersOpen} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding>
                    <ListItem disablePadding sx={{ pl: 4 }}>
                      <ListItemButton component={Link} to="/add-user" onClick={toggleDrawer(false)}>
                        <ListItemText primary="Add New" />
                      </ListItemButton>
                    </ListItem>
                    <ListItem disablePadding sx={{ pl: 4 }}>
                      <ListItemButton component={Link} to="/users-list" onClick={toggleDrawer(false)}>
                        <ListItemText primary="Users List" />
                      </ListItemButton>
                    </ListItem>
                  </List>
                </Collapse>
              </>
            )}

            <ListItem disablePadding onClick={() => setMobileUsersOpen(!mobileUsersOpen)}>
              <ListItemButton>
                <ListItemText primary="Leads" />
                {mobileUsersOpen ? <ExpandLess /> : <ExpandMore />}
              </ListItemButton>
            </ListItem>
            <Collapse in={mobileUsersOpen} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItem disablePadding sx={{ pl: 4 }}>
                  <ListItemButton component={Link} to="/newleads" onClick={toggleDrawer(false)}>
                    <ListItemText primary="New Lead" />
                  </ListItemButton>
                </ListItem>
                <ListItem disablePadding sx={{ pl: 4 }}>
                  <ListItemButton component={Link} to="/myleads" onClick={toggleDrawer(false)}>
                    <ListItemText primary="My Leads" />
                  </ListItemButton>
                </ListItem>
                <ListItem disablePadding sx={{ pl: 4 }}>
                  <ListItemButton component={Link} to="/validatelead" onClick={toggleDrawer(false)}>
                    <ListItemText primary="Validate Lead" />
                  </ListItemButton>
                </ListItem>
              </List>
            </Collapse>

            {["super_admin", "manager"].includes(role) && (
              <>
                <ListItem disablePadding onClick={() => setMobileUsersOpen(!mobileUsersOpen)}>
                  <ListItemButton>
                    <ListItemText primary="Marketing" />
                    {mobileUsersOpen ? <ExpandLess /> : <ExpandMore />}
                  </ListItemButton>
                </ListItem>
                <Collapse in={mobileUsersOpen} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding>
                    <ListItem disablePadding sx={{ pl: 4 }}>
                      <ListItemButton component={Link} to="/newinfluencer" onClick={toggleDrawer(false)}>
                        <ListItemText primary="New Influencer" />
                      </ListItemButton>
                    </ListItem>
                    <ListItem disablePadding sx={{ pl: 4 }}>
                      <ListItemButton component={Link} to="/users-list" onClick={toggleDrawer(false)}>
                        <ListItemText primary="View Influencer" />
                      </ListItemButton>
                    </ListItem>
                  </List>
                </Collapse>
              </>
            )}

            <ListItem disablePadding>
              <ListItemButton component={Link} to="/payout" onClick={toggleDrawer(false)}>
                <ListItemText primary="Payout" />
              </ListItemButton>
            </ListItem>

            <ListItem disablePadding>
              <ListItemButton component={Link} to="/userprofile" onClick={toggleDrawer(false)}>
                <ListItemText primary="Profile" />
              </ListItemButton>
            </ListItem>
          </>
        ) : (
          <>
            <ListItem disablePadding>
              <ListItemButton component={Link} to="/" onClick={toggleDrawer(false)}>
                <ListItemText primary="Home" />
              </ListItemButton>
            </ListItem>

            <ListItem disablePadding>
              <ListItemButton component={Link} to="/about" onClick={toggleDrawer(false)}>
                <ListItemText primary="About Us" />
              </ListItemButton>
            </ListItem>

            <ListItem disablePadding>
              <ListItemButton component={Link} to="/company-list" onClick={toggleDrawer(false)}>
                <ListItemText primary="Company List" />
              </ListItemButton>
            </ListItem>

            <ListItem disablePadding onClick={() => setMobileLoansOpen(!mobileLoansOpen)}>
              <ListItemButton>
                <ListItemText primary="Loans" />
                {mobileLoansOpen ? <ExpandLess /> : <ExpandMore />}
              </ListItemButton>
            </ListItem>
            <Collapse in={mobileLoansOpen} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                {[
                  { label: "Personal Loan", to: "/personal-loan" },
                  { label: "Vehicle Loan", to: "/vehicle-loan" },
                  { label: "Business Loan", to: "/business-loan" },
                  { label: "Home Loan", to: "/home-loan" },
                ].map((item, index) => (
                  <ListItem key={index} disablePadding sx={{ pl: 4 }}>
                    <ListItemButton component={Link} to={item.to} onClick={toggleDrawer(false)}>
                      <ListItemText primary={item.label} />
                    </ListItemButton>
                  </ListItem>
                ))}
              </List>
            </Collapse>

            <ListItem disablePadding>
              <ListItemButton component={Link} to="/contact" onClick={toggleDrawer(false)}>
                <ListItemText primary="Contact Us" />
              </ListItemButton>
            </ListItem>

            <ListItem disablePadding onClick={() => setMobileLinksOpen(!mobileLinksOpen)}>
              <ListItemButton>
                <ListItemText primary="Useful Links" />
                {mobileLinksOpen ? <ExpandLess /> : <ExpandMore />}
              </ListItemButton>
            </ListItem>
            <Collapse in={mobileLinksOpen} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                {[
                  { label: "Careers", to: "/careers" },
                  { label: "Consent Policy", to: "/consent-policy" },
                  { label: "Terms & Conditions", to: "/terms" },
                  { label: "Privacy Policy", to: "/privacy" },
                ].map((item, index) => (
                  <ListItem key={index} disablePadding sx={{ pl: 4 }}>
                    <ListItemButton component={Link} to={item.to} onClick={toggleDrawer(false)}>
                      <ListItemText primary={item.label} />
                    </ListItemButton>
                  </ListItem>
                ))}
              </List>
            </Collapse>
          </>
        )}

        {loggedIn && (
          <Box className="mobile-logout-wrapper">
            <Button fullWidth variant="contained" onClick={handleLogout}>
              Logout
            </Button>
          </Box>
        )}
      </List>
    </Drawer>
  );
};

export default MobileDrawer;